import { Component, EventEmitter, Injector, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { AppComponentBase } from '@shared/common/app-component-base';
import { DataService } from '../../auth/data.service';
import { ModalDirective } from 'ngx-bootstrap/modal';
import * as moment from 'moment';
import Litepicker from 'litepicker';
import { CreateFileTask } from '@shared/service-proxies/service-proxies';

@Component({
  selector: 'vf-do-later',
  templateUrl: './do-later.component.html'
})
export class DoLaterComponent extends AppComponentBase implements OnChanges {

  @Input() entityObj: any;
  @Input() showPopup: boolean;
  @ViewChild('doLaterModal') modal: ModalDirective;
  @Output() onClose = new EventEmitter();
  isDateSelected = false;
  selectedDate: any;
  dateString = '';
  showDatePicker = false;
  private startDatePicker: Litepicker;
  constructor(injector: Injector,
    private dataService: DataService) {
    super(injector);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.entityObj && changes.entityObj.currentValue !== undefined) {
      this.entityObj = changes.entityObj.currentValue;
    }
    if (changes.showPopup && changes.showPopup.currentValue !== undefined) {
      this.doSomething(changes.showPopup.currentValue);
    }
  }

  private doSomething(showPopup: boolean): void {
    if (showPopup) {
      this.modal.show();
      this.clearData();
      // this.selectedDate = moment(moment.parseZone(this.appSession.user.companyTzWorkDate).add(1, 'day').format('yyyy-MM-DD')).utc(true);
      this.updateBodyForCenterModalShow();
    }
  }

  private initializeDatePicker(): void {
    let sDate = moment.parseZone(this.selectedDate).format('MMM D, YYYY');
    let minD = moment().format('MMM D, YYYY');
    setTimeout(() => {
      if (this.modal.isShown) {
        let that = this;
        that.startDatePicker = new Litepicker({
          element: document.getElementById('doLaterDtPicker'),
          format: 'MMM D, YYYY',
          minDate: minD,
          autoApply: true,
          firstDay: 7,
          singleMode: true,
          startDate: that.selectedDate ? sDate : '',
          setup: (picker) => {
            picker.on('selected', (date1, date2) => {
              if (date1 && date1.dateInstance) {
                that.selectedDate = moment(date1.dateInstance).utc(true);
                that.dateString = moment(that.selectedDate).format('MM/DD/yyyy');
                // calculate difference between selected date and current date in days
                const diff = moment(that.selectedDate).diff(moment(moment.parseZone(this.appSession.user.companyTzWorkDate).format('MMM D, YYYY')), 'days');
                if (diff > 0) {
                  that.dateString = that.dateString + ' (' + diff + ' days from today)';
                } else {
                  that.dateString = that.dateString + ' (Today)';
                }
                if (that.dateString) {
                  that.showDatePicker = false;
                }
              }
              that.startDatePicker.hide();
            });
            picker.on('button:cancel', () => {
              that.startDatePicker.hide();
            });
          }
        });
      }
    }, 500);
  }

  private clearData(): void {
    this.selectedDate = null;
    this.isDateSelected = false;
    if (this.startDatePicker) {
      this.startDatePicker.clearSelection();
      this.startDatePicker.destroy();
    }
  }

  close(): void {
    if (this.modal && this.modal.isShown) {
      this.modal.hide();
      this.updateBodyForCenterModalHide();
      this.onClose.emit();
    }
  }

  save(): void {
    if (!this.isDateSelected) {
      // add 1 day to current date
      this.selectedDate = moment().add(1, 'day').utc(true);
    }
    if (this.selectedDate) {
      this.entityObj.startDate = this.selectedDate;
      this.dataService.addTaskToDoLater.next(this.entityObj);
      this.close();
    }
  }

  clearStartDate(): void {
    if (this.startDatePicker) {
      this.startDatePicker.clearSelection();
    }
    if (this.selectedDate) {
      this.selectedDate = '';
    }
  }

  chooseDate(isDateSelected): void {
    // destroy date picker and initialize again if needed
    this.dateString = '';
    if (!this.isDateSelected) {
      if (this.startDatePicker) {
        this.startDatePicker.clearSelection();
        this.startDatePicker.destroy();
      }
      this.selectedDate = null;
      this.showDatePicker = false;
    } else {
      this.showDatePicker = true;
      this.initializeDatePicker();
    }
  }

  updateShowDatePicker(): void {
    this.showDatePicker = true;
    if (this.startDatePicker) {
      this.startDatePicker.clearSelection();
      this.startDatePicker.destroy();
    }
    this.dateString = '';
    this.selectedDate = null;
    this.initializeDatePicker();
  }

}
